import { Playfair_Display, PT_Sans, Roboto } from 'next/font/google';

const playfairDisplayFont = Playfair_Display({
  weight: ['500'],
  style: ['normal'],
  subsets: ['latin'],
});
const ptSansFont = PT_Sans({
  weight: ['400', '700'],
  style: ['normal'],
  subsets: ['latin'],
});
const robotoFont = Roboto({
  weight: ['400', '700', '900'],
  style: ['normal'],
  subsets: ['latin'],
});

export { playfairDisplayFont, ptSansFont, robotoFont };
